import React 			from 'react';
import PropTypes 	from 'prop-types';

// this.props.classes : (optional) string of classes
// this.props.item 		: {image: string of image, name: (optional) string of name, link: (optional) string of link};
// this.props.qty 		: (optional) integer of qty
// this.props.extra 	: (optional) string of extra information

export default class SimpleProductCard extends React.Component
{
	constructor( props ) 
	{
		super( props );
	}

	render() {
		var {classes = '', item, qty = null, qty2 = null, extra, ratioHeight = false, showUnavailable = false, itemNameEllipses = true} = this.props;
		const altType = item.type != 'S' && item.type != 'P' && item.type != 'M';
		
		return (
			<article className={"simple-product-card " + classes + (ratioHeight ? ' simple-product-card--image-ratio' : '')} onClick={(e)=>this.processClick(e)}>
				{item.link ?
					<div className="simple-product-card__internal">
						<div className="simple-product-card__image">
							<a href={item.link} className="simple-product-card__image-internal">
								<img src={item.image} className="simple-product-card__image-item"/>
							</a>
						</div>
						{item.name ?
							<div className={"simple-product-card__info " + ((itemNameEllipses)?"overflow-ellipsis":"")}>
								<a href={item.link} className="link--inherit">
									{item.name}
								</a>
							</div>
						: null}
						{qty ?
							( qty2 ? <small className={"simple-product-card__qty " + (qty == qty2 ? "text-color--primaryRed":"text-color--grey")}>QTY: {qty}/{qty2}</small> : <small className="simple-product-card__qty text-color--grey">QTY: {qty}</small> )
						:	null
						}
						{extra ? <small className="simple-product-card__info overflow-ellipsis l-block">{extra}</small> : null}
						{showUnavailable && altType ?
							<p className="text-color--primaryRed l-margin-top--sm text--wrap">This item is not available in the BrickLink XP catalog.</p>
						: null}
					</div>
				:
					<div className="simple-product-card__internal">
						<div className="simple-product-card__image">
							<div className="simple-product-card__image-internal">
								<img src={item.image} className="simple-product-card__image-item"/>
							</div>
						</div>
						{item.name ?
							<div className={"simple-product-card__info " + ((itemNameEllipses)?"overflow-ellipsis":"")}>
								{item.name}
							</div>
						: null}
						{qty ?
							( qty2 ? <small className={"simple-product-card__qty " + (qty == qty2 ? "text-color--primaryRed":"text-color--grey")}>QTY: {qty}/{qty2}</small> : <small className="simple-product-card__qty text-color--grey">QTY: {qty}</small> )
						:	null
						}
						{extra ? <small className="simple-product-card__info overflow-ellipsis l-block">{extra}</small> : null}
						{showUnavailable && altType ?
							<p className="text-color--primaryRed l-margin-top--sm text--wrap">This item is not available in the BrickLink XP catalog.</p>
						: null}
					</div>
				}
			</article>
		);
	}

	processClick( e )
	{
		if ( this.props.onClickFunc )
			this.props.onClickFunc( e );
	}

	static getDataFromItem( item ) 
	{
		const dmItem	= item.dmItem;
		const dmImg		= item.dmImg;

		return SimpleProductCard.getDataFromItemAndImg( dmItem, dmImg );
	}

	static getDataFromItemAndImg( dmItem, dmImg ) 
	{
		return	{
				link:			blapp.url2.getCatalogItemPageUrl(dmItem)
			,	image: 			blapp.url2.getCatalogItemImgUrl(dmImg,"T2")
			,	name:			dmItem.strItemName
			,	type:			dmItem.typeItem
		}
	}

	static getDataFromOrderItem( dmOrderItem )
	{
		if ( dmOrderItem.dmItemWithImg ) {
			const dmItem = dmOrderItem.dmItemWithImg.dmItem;
			const dmImg	 = dmOrderItem.dmItemWithImg.dmImg;

			return {
					link:			blapp.url2.getCatalogItemPageUrl(dmItem)
				,	image:			dmOrderItem.strOrderItemImgUrl ? dmOrderItem.strOrderItemImgUrl : blapp.url2.getCatalogItemImgUrl(dmImg,"T2")
//				,	name:			dmItem.strItemName
				,	type:			dmItem.typeItem
			}
		} else {
			return {
				link:			""
			,	image:			dmOrderItem.strOrderItemImgUrl
//			,	name:			dmOrderItem.strDesc
			}
		}
	}

	static getDataFromCrowdModel( dmModel )
	{
		const	dmBasic	= dmModel.dmBasic;
		const	mainImg	= !_.isEmpty( dmModel.arrImgs ) ? dmModel.arrImgs[ 0 ].thumb.strUrl : blapp.url2.getUrlFromFileInfo( dmBasic.dmMainThumb );

		return {
			link:		blapp.url2.getCrowdProjectDesignViewUrl( dmBasic.idModel, dmModel )
		,	image:		mainImg
		,	name: 		dmModel.strName || dmBasic.strModelName
		}
	}
}

SimpleProductCard.propTypes = {
		classes: PropTypes.string
	,	item: PropTypes.shape({
			image: PropTypes.string.isRequired,
			name: PropTypes.string,
			link: PropTypes.string,
			type: PropTypes.string,
		})
	,	qty: PropTypes.number
	, qty2: PropTypes.number
	, extra: PropTypes.string
	, onClickFunc: PropTypes.func
	,	showUnavailable: PropTypes.bool
}
